export default "__VITE_ASSET__CnZLQ2zE__"